import { getScrollEventTarget, scrollContainerMediaQuery } from '@theme/scroll-container';

const DESKTOP_COLLECTION_QUERY = window.matchMedia('(min-width: 750px)');

/** @type {(() => void) | null} */
let cleanupDesktopTitle = null;

/**
 * Keep the collection title with the sticky desktop filters after the original
 * heading leaves the active scroll viewport. Fabric 4.1.1 scrolls
 * `.page-wrapper` on wide screens, while narrower layouts scroll the document.
 */
function setupDesktopCollectionTitle() {
  cleanupDesktopTitle?.();
  cleanupDesktopTitle = null;

  if (!document.body.classList.contains('template-collection') || !DESKTOP_COLLECTION_QUERY.matches) return;

  const mainContent = document.getElementById('MainContent');
  const heading = mainContent?.querySelector('h1');
  const verticalFacets = mainContent?.querySelector('.facets--vertical:not(.facets--drawer)');
  if (!(heading instanceof HTMLElement) || !(verticalFacets instanceof HTMLElement)) return;

  const title = document.createElement('div');
  title.className = 'sidebar-collection-title';
  title.hidden = true;
  title.textContent = heading.textContent?.trim() ?? '';
  verticalFacets.prepend(title);

  const scrollTarget = getScrollEventTarget();
  let frame = 0;

  const updateVisibility = () => {
    frame = 0;
    const scrollViewportTop = scrollContainerMediaQuery.matches
      ? (document.querySelector('.page-wrapper')?.getBoundingClientRect().top ?? 0)
      : 0;
    title.hidden = heading.getBoundingClientRect().bottom > scrollViewportTop;
  };

  const scheduleUpdate = () => {
    if (frame) return;
    frame = requestAnimationFrame(updateVisibility);
  };

  scrollTarget.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('resize', scheduleUpdate, { passive: true });
  scheduleUpdate();

  cleanupDesktopTitle = () => {
    scrollTarget.removeEventListener('scroll', scheduleUpdate);
    window.removeEventListener('resize', scheduleUpdate);
    if (frame) cancelAnimationFrame(frame);
    title.remove();
  };
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupDesktopCollectionTitle, { once: true });
} else {
  setupDesktopCollectionTitle();
}

DESKTOP_COLLECTION_QUERY.addEventListener('change', setupDesktopCollectionTitle);
scrollContainerMediaQuery.addEventListener('change', setupDesktopCollectionTitle);

document.addEventListener('shopify:collection:update', (event) => {
  const { promise } = /** @type {Event & { promise?: Promise<unknown> }} */ (event);

  if (promise) {
    promise.then(setupDesktopCollectionTitle, setupDesktopCollectionTitle);
  } else {
    requestAnimationFrame(setupDesktopCollectionTitle);
  }
});
